<div class="trim-box">
  <video
    #videoPlayer
    [src]="previewClipUrl || videoUrl"
    controls
    class="trim-video mb-3"
    (loadedmetadata)="onLoadedMetadata(videoPlayer)"
    (timeupdate)="onTimeUpdate(videoPlayer)">
  </video>

  <div class="trim-stats mb-3">
    <div class="trim-stat">
      <span>დაწყება</span>
      <strong>{{ formatTime(start) }}</strong>
    </div>
    <div class="trim-stat">
      <span>დასასრული</span>
      <strong>{{ formatTime(end) }}</strong>
    </div>
    <div class="trim-stat">
      <span>ხანგრძლივობა</span>
      <strong>{{ formatTime(end - start) }}</strong>
    </div>
    <div class="trim-stat">
      <span>მიმდინარე</span>
      <strong>{{ formatTime(currentTime) }}</strong>
    </div>
  </div>

  <div class="timeline-box mb-3">
    <div class="timeline-track"></div>

    <input
      type="range"
      class="trim-range trim-range-start"
      [min]="0"
      [max]="duration || 0"
      [step]="0.1"
      [(ngModel)]="start"
      (input)="onStartSliderChange(videoPlayer)" />

    <input
      type="range"
      class="trim-range trim-range-end"
      [min]="0"
      [max]="duration || 0"
      [step]="0.1"
      [(ngModel)]="end"
      (input)="onEndSliderChange()" />

    <div class="timeline-labels">
      <span *ngFor="let mark of getTimelineMarks()">{{ formatTime(mark) }}</span>
    </div>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input
          type="number"
          class="form-control"
          id="trimStart"
          [(ngModel)]="start"
          min="0"
          step="0.1"
          (change)="onStartSliderChange(videoPlayer)">
        <label for="trimStart">დასაწყისი (წამი)</label>
      </div>
      <div class="small text-muted mt-1">{{ formatTime(start) }}</div>
    </div>

    <div class="col-md-6">
      <div class="form-floating">
        <input
          type="number"
          class="form-control"
          id="trimEnd"
          [(ngModel)]="end"
          min="0"
          step="0.1"
          (change)="onEndSliderChange()">
        <label for="trimEnd">დასასრული (წამი)</label>
      </div>
      <div class="small text-muted mt-1">{{ formatTime(end) }}</div>
    </div>
  </div>

  <div class="d-flex flex-wrap gap-2 mb-3">
    <button class="btn btn-outline-light btn-sm" type="button" (click)="seekTo(videoPlayer, start)">
      დაწყებაზე გადასვლა
    </button>

    <button class="btn btn-outline-light btn-sm" type="button" (click)="seekTo(videoPlayer, end)">
      დასასრულზე გადასვლა
    </button>

    <button class="btn btn-outline-info btn-sm" type="button" (click)="previewSelection(videoPlayer)">
      Preview
    </button>

    <button class="btn btn-primary btn-sm d-flex align-items-center gap-2" type="button" [disabled]="loading" (click)="trim()">
      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"></span>
      <span>{{ loading ? 'მუშავდება...' : 'ამოჭრა' }}</span>
    </button>

    <button
      class="btn btn-success btn-sm"
      type="button"
      *ngIf="previewClipFilename"
      [disabled]="loading"
      (click)="saveReplace()">
      შენახვა
    </button>

    <button
      class="btn btn-outline-secondary btn-sm"
      type="button"
      *ngIf="previewClipFilename"
      (click)="cancelPreview()">
      გაუქმება
    </button>
  </div>

  <div *ngIf="successMessage" class="alert alert-success mb-0">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mb-0">
    {{ errorMessage }}
  </div>
</div>